import { render, staticRenderFns } from "./pickup-filters-sidebar.vue?vue&type=template&id=48765906&"
import script from "./pickup-filters-sidebar.vue?vue&type=script&lang=js&"
export * from "./pickup-filters-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./pickup-filters-sidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48765906')) {
      api.createRecord('48765906', component.options)
    } else {
      api.reload('48765906', component.options)
    }
    module.hot.accept("./pickup-filters-sidebar.vue?vue&type=template&id=48765906&", function () {
      api.rerender('48765906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/delivery-selector/pickup-filters/pickup-filters-sidebar.vue"
export default component.exports